import { render, staticRenderFns } from "./FlashcardsMenu.vue?vue&type=template&id=d79baf8c&scoped=true&"
import script from "./FlashcardsMenu.vue?vue&type=script&lang=js&"
export * from "./FlashcardsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79baf8c",
  null
  
)

export default component.exports